"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentConfirmedPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="payment-confirmed-page">
    <div class="confirmation-container">
        
        <div class="success-header">
            <div class="success-icon">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" fill="#10b981"/>
                    <path d="m9 12 2 2 4-4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <h1>${'payment.confirmed.title'.t()}</h1>
            <p class="success-message">${'payment.confirmed.message'.t()}</p>
        </div>

        
        <div class="payment-details-card">
            <h2>${'payment.confirmed.details'.t()}</h2>
            
            <div class="detail-row" ?hidden="${x => { var _a; return !x.paymentId && !((_a = x.paymentDetails) === null || _a === void 0 ? void 0 : _a.id); }}">
                <span class="detail-label">${'payment.id'.t()}:</span>
                <span class="detail-value">${x => { var _a; return ((_a = x.paymentDetails) === null || _a === void 0 ? void 0 : _a.id) || x.paymentId; }}</span>
            </div>

            <div class="detail-row" ?hidden="${x => !x.formattedAmount}">
                <span class="detail-label">${'payment.amount'.t()}:</span>
                <span class="detail-value amount">${x => x.formattedAmount}</span>
            </div>

            <div class="detail-row" ?hidden="${x => !x.providerName}">
                <span class="detail-label">${'payment.provider'.t()}:</span>
                <span class="detail-value">${x => x.providerName}</span>
            </div>

            <div class="detail-row">
                <span class="detail-label">${'payment.confirmed.date'.t()}:</span>
                <span class="detail-value">${x => x.paymentDate}</span>
            </div>

            <div class="detail-row" ?hidden="${x => !x.paymentIntent}">
                <span class="detail-label">${'payment.confirmed.paymentIntent'.t()}:</span>
                <span class="detail-value payment-intent">${x => x.paymentIntent}</span>
            </div>
        </div>

        
        <div class="loading-card" ?hidden="${x => !x.loading}">
            <div class="loading-spinner"></div>
            <p>${'common.loading'.t()}</p>
        </div>

        
        <div class="error-card" ?hidden="${x => !x.errorMessage}">
            <div class="error-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" fill="#ef4444"/>
                    <path d="m15 9-6 6m0-6 6 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <p>${x => x.errorMessage}</p>
        </div>

        
        <div class="upgrade-success-card" ?hidden="${x => !x.paymentDetails || x.loading}">
            <div class="upgrade-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L3.09 8.26 12 12l8.91-3.74L12 2z" fill="#3b82f6"/>
                    <path d="M21 10v6c0 2.21-1.79 4-4 4H7c-2.21 0-4-1.79-4-4v-6" stroke="#3b82f6" stroke-width="2" fill="none"/>
                    <path d="m9 22 3-3 3 3" stroke="#3b82f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <h3>${'payment.confirmed.accountUpgraded'.t()}</h3>
            <p>${'payment.confirmed.accountUpgradedMessage'.t()}</p>
        </div>

        
        <div class="next-steps-card">
            <h3>${'payment.confirmed.nextSteps'.t()}</h3>
            <p>${'payment.confirmed.nextStepsMessage'.t()}</p>
        </div>

        
        <div class="action-buttons">
            <button 
                class="btn btn-primary"
                @click="${x => x.goToConversations()}">
                ${'payment.confirmed.startChatting'.t()}
            </button>            
        </div>

        
        <div class="receipt-info">
            <p class="receipt-text">
                ${'payment.confirmed.receiptInfo'.t()}
            </p>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.payment-confirmed-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.payment-confirmed-page .confirmation-container {
  max-width: 600px;
  width: 100%;
  background: var(--color-neutral-layer-1, #ffffff);
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.payment-confirmed-page .success-header {
  text-align: center;
  padding: 48px 32px 32px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}
.payment-confirmed-page .success-header .success-icon {
  margin-bottom: 24px;
}
.payment-confirmed-page .success-header .success-icon svg {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
}
.payment-confirmed-page .success-header h1 {
  margin: 0 0 12px 0;
  font-size: 2rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.payment-confirmed-page .success-header .success-message {
  margin: 0;
  font-size: 1.1rem;
  opacity: 0.95;
  font-weight: 400;
}
.payment-confirmed-page .payment-details-card {
  padding: 32px;
  border-bottom: 1px solid var(--color-neutral-stroke-rest, #e5e7eb);
}
.payment-confirmed-page .payment-details-card h2 {
  margin: 0 0 24px 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-neutral-foreground-rest, #374151);
}
.payment-confirmed-page .payment-details-card .detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid var(--color-neutral-stroke-divider, #f3f4f6);
}
.payment-confirmed-page .payment-details-card .detail-row:last-child {
  border-bottom: none;
}
.payment-confirmed-page .payment-details-card .detail-row .detail-label {
  font-weight: 500;
  color: var(--color-neutral-foreground-2, #6b7280);
}
.payment-confirmed-page .payment-details-card .detail-row .detail-value {
  font-weight: 600;
  color: var(--color-neutral-foreground-rest, #374151);
}
.payment-confirmed-page .payment-details-card .detail-row .detail-value.amount {
  font-size: 1.125rem;
  color: var(--color-brand-foreground-1, #3b82f6);
}
.payment-confirmed-page .payment-details-card .detail-row .detail-value.payment-intent {
  font-family: monospace;
  font-size: 0.875rem;
  background: var(--color-neutral-layer-2, #f9fafb);
  padding: 4px 8px;
  border-radius: 4px;
  word-break: break-all;
}
.payment-confirmed-page .loading-card {
  padding: 32px;
  text-align: center;
}
.payment-confirmed-page .loading-card .loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--color-neutral-stroke-rest, #e5e7eb);
  border-top: 3px solid var(--color-brand-background-1, #3b82f6);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}
.payment-confirmed-page .loading-card p {
  margin: 0;
  color: var(--color-neutral-foreground-2, #6b7280);
}
.payment-confirmed-page .error-card {
  padding: 32px;
  text-align: center;
  background: var(--color-danger-background, #fef2f2);
  border-left: 4px solid var(--color-danger-foreground, #dc2626);
}
.payment-confirmed-page .error-card .error-icon {
  margin-bottom: 16px;
}
.payment-confirmed-page .error-card p {
  margin: 0;
  color: var(--color-danger-foreground, #dc2626);
  font-weight: 500;
}
.payment-confirmed-page .upgrade-success-card {
  padding: 24px 32px;
  background: var(--color-brand-background-tint, #eff6ff);
  border-left: 4px solid var(--color-brand-background-1, #3b82f6);
  text-align: center;
}
.payment-confirmed-page .upgrade-success-card .upgrade-icon {
  margin-bottom: 16px;
}
.payment-confirmed-page .upgrade-success-card h3 {
  margin: 0 0 8px 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-brand-foreground-1, #3b82f6);
}
.payment-confirmed-page .upgrade-success-card p {
  margin: 0;
  color: var(--color-neutral-foreground-2, #6b7280);
}
.payment-confirmed-page .next-steps-card {
  padding: 24px 32px;
  background: var(--color-neutral-layer-2, #f9fafb);
}
.payment-confirmed-page .next-steps-card h3 {
  margin: 0 0 12px 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-neutral-foreground-rest, #374151);
}
.payment-confirmed-page .next-steps-card p {
  margin: 0;
  color: var(--color-neutral-foreground-2, #6b7280);
  line-height: 1.5;
}
.payment-confirmed-page .action-buttons {
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.payment-confirmed-page .receipt-info {
  padding: 16px 32px 32px;
  text-align: center;
}
.payment-confirmed-page .receipt-info .receipt-text {
  margin: 0;
  font-size: 0.875rem;
  color: var(--color-neutral-foreground-3, #9ca3af);
  line-height: 1.4;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .payment-confirmed-page {
    padding: 16px;
  }
  .payment-confirmed-page .confirmation-container {
    border-radius: 12px;
  }
  .payment-confirmed-page .success-header {
    padding: 32px 24px 24px;
  }
  .payment-confirmed-page .success-header h1 {
    font-size: 1.75rem;
  }
  .payment-confirmed-page .success-header .success-message {
    font-size: 1rem;
  }
  .payment-confirmed-page .payment-details-card,
  .payment-confirmed-page .action-buttons {
    padding: 24px;
  }
  .payment-confirmed-page .next-steps-card,
  .payment-confirmed-page .upgrade-success-card {
    padding: 20px 24px;
  }
  .payment-confirmed-page .action-buttons .btn {
    padding: 14px 24px;
    font-size: 1rem;
  }
  .payment-confirmed-page .detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .payment-confirmed-page .detail-row .detail-value.payment-intent {
    width: 100%;
    word-break: break-all;
  }
}
@media (max-width: 480px) {
  .payment-confirmed-page .action-buttons .btn {
    width: 100%;
  }
}

[hidden] {
  display: none !important;
}`;
const shadowOptions = { "mode": "open" };
let PaymentConfirmedPage = class PaymentConfirmedPage extends client_1.RWSViewComponent {
    constructor(apiService) {
        super();
        this.apiService = apiService;
        this.paymentIntent = '';
        this.paymentId = '';
        this.amount = '';
        this.currency = '';
        this.provider = '';
        this.loading = false;
        this.paymentDetails = null;
        this.errorMessage = '';
    }
    connectedCallback() {
        super.connectedCallback();
        this.loadPaymentDetails();
    }
    /**
     * Load payment details from URL parameters or API
     */
    async loadPaymentDetails() {
        // Extract payment details from URL parameters if available
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('payment_intent')) {
            this.paymentIntent = urlParams.get('payment_intent') || '';
        }
        if (urlParams.has('payment_id')) {
            this.paymentId = urlParams.get('payment_id') || '';
        }
        if (urlParams.has('amount')) {
            this.amount = urlParams.get('amount') || '';
        }
        if (urlParams.has('currency')) {
            this.currency = urlParams.get('currency') || '';
        }
        if (urlParams.has('provider')) {
            this.provider = urlParams.get('provider') || '';
        }
        // If we have a payment ID, fetch additional details
        if (this.paymentId) {
            await this.fetchPaymentStatus();
        }
    }
    /**
     * Fetch payment status from API
     */
    async fetchPaymentStatus() {
        if (!this.paymentId)
            return;
        this.loading = true;
        this.errorMessage = '';
        try {
            const response = await this.apiService.back.get('payment.status', {
                routeParams: { id: this.paymentId }
            });
            if (response && response.success) {
                this.paymentDetails = response.data;
            }
            else {
                this.errorMessage = (response === null || response === void 0 ? void 0 : response.error) || 'payment.confirmed.fetchError'.t();
            }
        }
        catch (error) {
            console.error('Error fetching payment status:', error);
            this.errorMessage = 'payment.confirmed.fetchError'.t();
        }
        finally {
            this.loading = false;
        }
    }
    /**
     * Navigate to account page
     */
    goToAccount() {
        component_1.SiteMenu.goto.bind(this)('/account/upgrade');
    }
    /**
     * Navigate to home page
     */
    goToHome() {
        component_1.SiteMenu.goto.bind(this)('/');
    }
    /**
     * Navigate to conversations
     */
    goToConversations() {
        component_1.SiteMenu.goto.bind(this)('/ai/chat');
    }
    /**
     * Get formatted amount display
     */
    get formattedAmount() {
        if (this.paymentDetails) {
            return `${this.paymentDetails.amount} ${this.paymentDetails.currency.toUpperCase()}`;
        }
        if (this.amount && this.currency) {
            return `${this.amount} ${this.currency.toUpperCase()}`;
        }
        return '';
    }
    /**
     * Get provider display name
     */
    get providerName() {
        var _a;
        if ((_a = this.paymentDetails) === null || _a === void 0 ? void 0 : _a.provider) {
            switch (this.paymentDetails.provider) {
                case 'stripe':
                    return 'Stripe';
                default:
                    return this.paymentDetails.provider;
            }
        }
        if (this.provider) {
            switch (this.provider) {
                case 'stripe':
                    return 'Stripe';
                default:
                    return this.provider;
            }
        }
        return 'payment.confirmed.unknownProvider'.t();
    }
    /**
     * Get payment date display
     */
    get paymentDate() {
        var _a;
        if ((_a = this.paymentDetails) === null || _a === void 0 ? void 0 : _a.paidAt) {
            return new Date(this.paymentDetails.paidAt).toLocaleString();
        }
        return new Date().toLocaleString();
    }
};
exports.PaymentConfirmedPage = PaymentConfirmedPage;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], PaymentConfirmedPage.prototype, "paymentIntent", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], PaymentConfirmedPage.prototype, "paymentId", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], PaymentConfirmedPage.prototype, "amount", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], PaymentConfirmedPage.prototype, "currency", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], PaymentConfirmedPage.prototype, "provider", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], PaymentConfirmedPage.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], PaymentConfirmedPage.prototype, "paymentDetails", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], PaymentConfirmedPage.prototype, "errorMessage", void 0);
exports.PaymentConfirmedPage = PaymentConfirmedPage = __decorate([
    (0, client_1.RWSView)('payment-confirmed-page', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, client_1.ApiService),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object])
], PaymentConfirmedPage);
PaymentConfirmedPage.defineComponent();
